import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import { RateioGeralContaPagarLista } from "../../../domain/models/rateio_geral_contas_pagar_lista"
import { GenerateRateioGeralListaColumns } from "./columns"
import { useRateioGeralListaViewModel } from "../../viewModels/rateio_geral_lista_view_model"
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import { RateioGeralReportModal } from "./components/rateio_geral_report_modal"


export const RateioGeralLista = () => {

    const viewModel = useRateioGeralListaViewModel();

    const columnsDef = useMemo(() => {

        return GenerateRateioGeralListaColumns({
            onActionEdit: viewModel.handleEditRateioGeral,
            onActionDelete: viewModel.handleRateioGeralDeleteOpenState,

        });

    }, [viewModel.handleEditRateioGeral, viewModel.handleRateioGeralDeleteOpenState]);

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleRelatorioOpenState(true)}>
                                    Relatório
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-2 flex-col md:p-4 px-5 pt-2">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Typography className="text-primary-green">
                        Rateio Geral                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Rateio Geral</h1>
                        <p>Pesquisar </p>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>


                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                ddlCentroCusto={viewModel.ddlCentroCusto}
                                selectedIdsCentroCusto={viewModel.filters.idsCentroCusto ?? []}
                                handleIdsCentroCustoChange={viewModel.handleIdCentroCustoChange}
                                handleDataPagoRangeChange={viewModel.handleDataPagoRangeChange}
                                handleNroNotaFiscalChange={viewModel.handleNroNotaFiscalChange}
                                onClearFilters={viewModel.handleClearFilters}
                                dataDe={viewModel.filters.dataDe ?? null}
                                dataAte={viewModel.filters.dataAte ?? null}
                                nroNotaFiscal={viewModel.filters.nroNotaFiscal ?? ''}

                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="rateio_geral_conta_lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: RateioGeralContaPagarLista) => row.idContasPagar}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.rateioGeralContaPagarLista}
                                    rowCount={viewModel.rateioGeralContaPagarLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        right: ['idContasPagar'],
                                    }}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>

                        </>
                    )
                }

            </div >

            <DeleteDialog
                open={viewModel.openDeleteModal}
                onClose={() => viewModel.handleRateioGeralDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este item?`}
                onDelete={viewModel.handleConfirmarDeletarRateioGeral}
            />

            <RateioGeralReportModal
                open={viewModel.openRelatorioModal}
                saving={viewModel.saving}
                ddlCentroCusto={viewModel.ddlCentroCusto}
                ddlFornecedor={viewModel.ddlFornecedor}
                ddlFuncionario={viewModel.ddlFuncionario}
                ddlOrdemCompra={viewModel.ddlOrdemCompra}
                ddlNroMedicao={viewModel.ddlPgtoMedicao}
                onClose={() => viewModel.handleRelatorioOpenState(false)}
                onSubmit={viewModel.handleRateioReportSubmit}

            />

            <ReportViewerModal
                reportViewerState={viewModel.reportViewerState}
            />

        </>
    )
}
